import React from "react";
import Header from "./Components/Header";
import BrandIdentity from "./Components/Brand-Identity/BrandIdentity";
import PropertiesSection from "./Properties/PropertiesSection";

function App() {
  return (
    <div className="App">
      <Header />
      <BrandIdentity />
      <PropertiesSection />
    </div>
  );
}

export default App;
